import React, { Fragment } from 'react';

// Logos
import molochLogo from '../../../img/logos/moloch.jpeg';
import daoStackLogo from '../../../img/logos/daostack.jpeg';
import compoundLogo from '../../../img/logos/compound.png';
import _0xLogo from '../../../img/logos/0x.jpeg';
import _1hiveLogo from '../../../img/logos/1hive.png';
import abridgedLogo from '../../../img/logos/abridged.jpeg';
import aDAOlogo from '../../../img/logos/adao.png';
import agoraLogo from '../../../img/logos/agora.png';
import aragonLogo from '../../../img/logos/aragon.png';
import avenueLogo from '../../../img/logos/avenue.png';
import balancerLogo from '../../../img/logos/balancer.png';
import boardroomLogo from '../../../img/logos/boardroom.jpeg';
import bribeLogo from '../../../img/logos/bribe.jpg';
import ceramicLogo from '../../../img/logos/ceramic.png';
import charmverseLogo from '../../../img/logos/charmverse.png';
import coinbaseLogo from '../../../img/logos/coinbase.png';
import colonyLogo from '../../../img/logos/colony.png';
import commonwealthLogo from '../../../img/logos/commonwealth.png';
import consensysLogo from '../../../img/logos/consensys.png';
import consensysMeshLogo from '../../../img/logos/consensys-mesh.png';
import curveLabsLogo from '../../../img/logos/curvelabs.jpeg';
import daodaoLogo from '../../../img/logos/daodao.png';
import daoMastersLogo from '../../../img/logos/daomasters.jpeg';
import developerDAOLogo from '../../../img/logos/developerdao.jpg';
import daoCollectiveLogo from '../../../img/logos/daoresearchcollective.png';
import deepDAOlogo from '../../../img/logos/deepdao.jpeg';
import dOrgLogo from '../../../img/logos/dorg.png';
import ethereumLogo from '../../../img/logos/ethereumfoundation.png';
import etherscanLogo from '../../../img/logos/etherscan.png';
import figmentLogo from '../../../img/logos/figment.jpeg';
import galaxyDigitalLogo from '../../../img/logos/galaxydigital.jpeg';
import gitcoinLogo from '../../../img/logos/gitcoin.png';
import githubLogo from '../../../img/logos/github.png';
import gnosisLogo from '../../../img/logos/gnosis.png';
import govrnLogo from '../../../img/logos/govrn.png';
import interchainLogo from '../../../img/logos/interchain.png';
import klerosLogo from '../../../img/logos/kleros.png';
import kycdaoLogo from '../../../img/logos/kycdao.jpg';
import litProtocolLogo from '../../../img/logos/litprotocol.png';
import logosLogo from '../../../img/logos/logos.jpg';
import messariLogo from '../../../img/logos/messari.jpeg';
import metacartelLogo from '../../../img/logos/metacartel.png';
import metagovLogo from '../../../img/logos/metagov.png';
import mirrorLogo from '../../../img/logos/mirror.png';
import nearLogo from '../../../img/logos/near.png';
import olympusLogo from '../../../img/logos/olympusdao.jpeg';
import openZepellinLogo from '../../../img/logos/openzeppelin.jpeg';
import opolisLogo from '../../../img/logos/opolis.png';
import orcaLogo from '../../../img/logos/orca.jpeg';
import otherInternetLogo from '../../../img/logos/otherinternet.png';
import otterspaceLogo from '../../../img/logos/otterspace.png';
import paladinLogo from '../../../img/logos/paladin.png';
import polygonLogo from '../../../img/logos/polygondao.webp';
import protocolLogo from '../../../img/logos/protocol.png';
import rabbitholeLogo from '../../../img/logos/rabbithole.jpg';
import radicalxchangeLogo from '../../../img/logos/radicalxchange.png';
import radicleLogo from '../../../img/logos/radicle.png';
import sismoLogo from '../../../img/logos/sismo.png';
import smartContractResearchLogo from '../../../img/logos/scrf.png';
import snapshotLogo from '../../../img/logos/snapshot.jpeg';
import solanaLogo from '../../../img/logos/solana.png';
import spruceLogo from '../../../img/logos/spruce.jpeg';
import stationLogo from '../../../img/logos/station.jpg';
import superDAOlogo from '../../../img/logos/superdao.png';
import syndicateLogo from '../../../img/logos/syndicate.jpeg';
import tallyLogo from '../../../img/logos/tally.jpeg';
import tenderlyLogo from '../../../img/logos/tenderly.jpeg';
import tributeLogo from '../../../img/logos/tribute.png';
import utopiaLogo from '../../../img/logos/utopialabs.webp';
import wildfireLogo from '../../../img/logos/wildfiredao.png';
import wonderverseLogo from '../../../img/logos/wonderverse.png';

const MemberLogos = (props) => {
    return (
        <div className="logos">
            <a href="https://0x.org/" target="_blank"><img src={_0xLogo} alt="0x" /></a>
            <a href="https://1hive.org/" target="_blank"><img src={_1hiveLogo} alt="1Hive" /></a>
            <a href="https://abridged.io/" target="_blank"><img src={abridgedLogo} alt="Abridged" /></a>
            <a href="https://www.theadadao.com" target="_blank"><img src={aDAOlogo} alt="ADAO" /></a>
            <a href="https://agora.xyz/" target="_blank"><img src={agoraLogo} alt="Agora Space" /></a>
            <a href="https://aragon.org/" target="_blank"><img src={aragonLogo} alt="Aragon" /></a>
            <a href="https://avenue.place/" target="_blank"><img src={avenueLogo} alt="Avenue" /></a>
            <a href="https://balancer.finance/" target="_blank"><img src={balancerLogo} alt="BalancerDAO" /></a>
            <a href="https://www.boardroom.info/" target="_blank"><img src={boardroomLogo} alt="Boardroom" /></a>
            <a href="https://www.bribe.xyz/" target="_blank"><img src={bribeLogo} alt="Bribe" /></a>
            <a href="https://ceramic.network/" target="_blank"><img src={ceramicLogo} alt="Ceramic" /></a>
            <a href="https://charmverse.io/" target="_blank"><img src={charmverseLogo} alt="Charmverse" /></a>	
            <a href="https://www.coinbase.com/" target="_blank"><img src={coinbaseLogo} alt="Coinbase" /></a>
            <a href="https://colony.io/" target="_blank"><img src={colonyLogo} alt="Colony" /></a>
            <a href="https://commonwealth.im/" target="_blank"><img src={commonwealthLogo} alt="Commonwealth" /></a>
            <a href="https://compound.finance/" target="_blank"><img src={compoundLogo} alt="Compound" /></a>
            <a href="https://consensys.net/" target="_blank"><img src={consensysLogo} alt="Consensys" /></a>
            <a href="https://mesh.xyz/" target="_blank"><img src={consensysMeshLogo} alt="Consensys Mesh" /></a>
            <a href="https://www.curvelabs.eu/" target="_blank"><img src={curveLabsLogo} alt="Curve Labs" /></a>
            <a href="https://daodao.zone/" target="_blank"><img src={daodaoLogo} alt="DAO DAO" /></a>
            <a href="https://daomasters.xyz/" target="_blank"><img src={daoMastersLogo} alt="DAO Masters" /></a>
            <a href="https://www.developerdao.com/" target="_blank"><img src={developerDAOLogo} alt="Developer DAO" /></a>
            <a href="https://www.daocollective.xyz/" target="_blank"><img src={daoCollectiveLogo} alt="DAO Research Collective" /></a>
            <a href="https://daostack.io/" target="_blank"><img src={daoStackLogo} alt="DAOstack" /></a>
            <a href="https://deepdao.io/" target="_blank"><img src={deepDAOlogo} alt="DeepDAO" /></a>
            <a href="https://www.dorg.tech/" target="_blank"><img src={dOrgLogo} alt="dOrg" /></a>
            <a href="https://ethereum.org/en/foundation/" target="_blank"><img src={ethereumLogo} alt="Ethereum Foundation" /></a>
            <a href="https://etherscan.io/" target="_blank"><img src={etherscanLogo} alt="Etherscan" /></a>
            <a href="https://www.figment.io/" target="_blank"><img src={figmentLogo} alt="Figment" /></a>
            <a href="http://galaxydigital.io/" target="_blank"><img src={galaxyDigitalLogo} alt="Galaxy Digital" /></a>
            <a href="https://gitcoin.co/" target="_blank"><img src={gitcoinLogo} alt="Gitcoin" /></a>
            <a href="https://github.com/" target="_blank"><img src={githubLogo} alt="GitHub" /></a>
            <a href="https://gnosis.io/" target="_blank"><img src={gnosisLogo} alt="Gnosis" /></a>
            <a href="https://linktr.ee/Govrn" target="_blank"><img src={govrnLogo} alt="Govrn" /></a>
            <a href="https://interchain.io/" target="_blank"><img src={interchainLogo} alt="Interchain Foundation" /></a>
            <a href="https://kleros.io/" target="_blank"><img src={klerosLogo} alt="Kleros" /></a>
            <a href="https://kycdao.xyz/" target="_blank"><img src={kycdaoLogo} alt="kycDAO" /></a>
            <a href="https://litprotocol.com/" target="_blank"><img src={litProtocolLogo} alt="Lit Protocol" /></a>
            <a href="https://logos.xyz/" target="_blank"><img src={logosLogo} alt="Logos" /></a>
            <a href="https://messari.io/" target="_blank"><img src={messariLogo} alt="Messari" /></a>
            <a href="https://metacartel.xyz/" target="_blank"><img src={metacartelLogo} alt="MetaCartel Ventures" /></a>
            <a href="https://metagov.org/" target="_blank"><img src={metagovLogo} alt="Metagov" /></a>
            <a href="https://mirror.xyz/" target="_blank"><img src={mirrorLogo} alt="Mirror" /></a>
            <a href="https://github.com/MolochVentures/moloch" target="_blank"><img src={molochLogo} alt="Moloch" /></a>
            <a href="https://near.org/" target="_blank"><img src={nearLogo} alt="NEAR" /></a>
            <a href="https://www.olympusdao.finance/" target="_blank"><img src={olympusLogo} alt="OlympusDAO" /></a>
            <a href="https://openzeppelin.com/" target="_blank"><img src={openZepellinLogo} alt="OpenZeppelin" /></a>
            <a href="https://opolis.co/" target="_blank"><img src={opolisLogo} alt="Opolis" /></a>
            <a href="https://www.orcaprotocol.org/" target="_blank"><img src={orcaLogo} alt="Orca Protocol" /></a>
            <a href="https://otherinter.net/" target="_blank"><img src={otherInternetLogo} alt="Other Internet" /></a>
            <a href="https://otterspace.xyz/" target="_blank"><img src={otterspaceLogo} alt="Otterspace" /></a>
            <a href="https://paladin.vote/" target="_blank"><img src={paladinLogo} alt="Paladin" /></a>
            <a href="https://polygon.community/" target="_blank"><img src={polygonLogo} alt="Polygon DAO" /></a>
            <a href="https://protocol.ai/" target="_blank"><img src={protocolLogo} alt="Protocol Labs" /></a>	
            <a href="https://rabbithole.gg/" target="_blank"><img src={rabbitholeLogo} alt="Rabbit Hole" /></a>
            <a href="https://www.radicalxchange.org/" target="_blank"><img src={radicalxchangeLogo} alt="RadicalxChange" /></a>
            <a href="https://radicle.xyz/" target="_blank"><img src={radicleLogo} alt="Radicle" /></a>
            <a href="https://sismo.io/" target="_blank"><img src={sismoLogo} alt="Sismo" /></a>
            <a href="https://www.smartcontractresearch.org/" target="_blank"><img src={smartContractResearchLogo} alt="Smart Contract Research Forum" /></a>
            <a href="https://snapshot.org/" target="_blank"><img src={snapshotLogo} alt="Snapshot" /></a>
            <a href="https://solana.com/" target="_blank"><img src={solanaLogo} alt="Solana" /></a>
            <a href="https://www.spruceid.com/" target="_blank"><img src={spruceLogo} alt="Spruce" /></a>
            <a href="https://www.station.express/" target="_blank"><img src={stationLogo} alt="Station" /></a>
            <a href="https://superdao.co/" target="_blank"><img src={superDAOlogo} alt="Superdao" /></a>
            <a href="https://syndicate.io/" target="_blank"><img src={syndicateLogo} alt="Syndicate" /></a>
            <a href="https://www.withtally.com/" target="_blank"><img src={tallyLogo} alt="Tally" /></a>
            <a href="https://tenderly.co/" target="_blank"><img src={tenderlyLogo} alt="Tenderly" /></a>
            <a href="https://tributedao.com/" target="_blank"><img src={tributeLogo} alt="Tribute Labs" /></a>
            <a href="https://www.utopialabs.com/" target="_blank"><img src={utopiaLogo} alt="Utopia Labs" /></a>
            <a href="https://mirror.xyz/james.eth/71ibzWJvs3Frqu3beIzAtcQu5sJ2k8Hz15svQhBWKvI" target="_blank"><img src={wildfireLogo} alt="Wildfire DAO" /></a>	
            <a href="https://www.wonderverse.xyz/" target="_blank"><img src={wonderverseLogo} alt="Wonderverse" /></a>
        </div>
    )
}

export default MemberLogos;